module.exports = __webpack_public_path__ + "static/client-side-rendering-diagram-5fccd8ce6f123b49293236748633acb5.png";